export default {
  esg_dashboard: {
    title: 'Tableau de bord',
  },
  improvement_plans: {
    title: "Plan d'amélioration",
  },
  question_group_section: {
    card_title: 'Enquêtes sans réponse',
    list_header_buyer_company_name: 'Acheteur',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: 'Délai',
    list_header_status: 'Statut',
    number_of_answered_label: 'Questions répondues',
    // number_of_answered_unit: '',
    number_of_answered: 'En cours： {answered}/{total}',
    status_re_answer_request: 'Demande de retrait en cours',
    answer: 'Réponse',
    withdrawn: 'Retiré',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: 'Acheteur',
    list_header_question: 'Enquête',
    list_header_create_at: "Date d'émission",
    list_header_deadline: "Date d'expiration",
    list_header_status: 'Statut',
    limit_one_year: 'Un an à partir de la date de délivrance',
    esg_score: 'Score ESG',
    esg_rating: 'Note ESG',
    detail: 'Détail',
  },
  faq_section: {
    card_title: 'FAQ',
    faq_why_request: {
      question:
        "Pourquoi ai-je reçu un questionnaire ASUENE ESG de la part d'une société partenaire ?",
      answer:
        "Ces dernières années, l'approvisionnement durable est devenu une tendance importante et les entreprises sont tenues de prendre en compte les questions ESG tout au long de leur chaîne d'approvisionnement.Les entreprises doivent non seulement vérifier et divulguer leurs propres activités ESG, mais aussi vérifier et encourager leurs partenaires commerciaux à prendre des mesures liées aux activités ESG.",
    },
    faq_what_benefit: {
      question: "Quels sont les avantages de répondre à l'ASUENE ESG ?",
      answer:
        "Il y a trois avantages à répondre à une enquête à travers l'ASUENE ESG.\n1) Comprendre les forces et les faiblesses de votre entreprise en matière d'ESG\n2) Comparer l'évaluation de votre entreprise avec celle d'autres entreprises de votre secteur d'activité\n3) Promouvoir les activités ESG de votre entreprise en divulguant les résultats de votre évaluation.",
    },
    list: 'Voir la liste',
  },
  contact_section: {
    card_title: 'Nous contacter',
    description:
      "Si vous avez des questions sur l'enquête ou sur la manière d'y répondre, n'hésitez pas à nous contacter à tout moment.\nSi vous souhaitez recevoir un soutien plus spécifique pour améliorer vos activités ESG, vous pouvez demander l'aide de notre consultant.",
    inquiry: 'Nous contacter',
  },
}
